const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrayRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 396.81,
    width: 59.89,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.33,
    y: 391.4,
    width: 52.57,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.24,
    y: 396.69,
    width: 16.35,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.11,
    y: 391.28,
    width: 48.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.22,
    y: 391.28,
    width: 10.43,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.68,
    y: 393.43,
    width: 33.65,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,196.25A154.63,154.63,0,0,0,95.36,350.89H404.64A154.63,154.63,0,0,0,250,196.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,382.4H114.58s39.16-26,77.42-49.15,60-22.88,82.55-6.19,68.49,2.7,104-4.39C447,309,450.54,366.69,483.23,382.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.28,382.4H413s-23.33-.09-69.66-23.2-65-20.54-92.34-3.85S185.28,334.46,122,328.67C48.63,322,52.78,382.4,18.28,382.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.04,
    cy: 78.2,
    r: 14.26,
    transform: "matrix(0.53, -0.85, 0.85, 0.53, 120.83, 373.13)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.19,
    cy: 163.09,
    r: 9.31,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.7,
    cy: 207.76,
    r: 9.74,
    transform: "translate(127.23 576.29) rotate(-76.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.36,
    cy: 38.56,
    r: 7.92,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.66,84a8.23,8.23,0,0,0-11,4.27,8.24,8.24,0,0,0-10.89,4.47,8.43,8.43,0,0,0,4.64,10.79l11.57,5a3.64,3.64,0,0,0,4.77-1.91l5-11.57A8.43,8.43,0,0,0,95.66,84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.88,122.18a7.17,7.17,0,0,0-9.13-4.59,7.16,7.16,0,0,0-9.22-4.41,7.31,7.31,0,0,0-4.25,9.27l3.53,10.34a3.17,3.17,0,0,0,4,2l10.34-3.54A7.31,7.31,0,0,0,443.88,122.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.92,48.11a2.67,2.67,0,1,1-2.67-2.67A2.66,2.66,0,0,1,338.92,48.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,78.2a2.67,2.67,0,1,1-2.67-2.67A2.66,2.66,0,0,1,328.72,78.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.11,243.41a2.67,2.67,0,1,1-2.67-2.67A2.67,2.67,0,0,1,86.11,243.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.78,256.51a2.67,2.67,0,1,1-2.67-2.67A2.68,2.68,0,0,1,428.78,256.51Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sky--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.6,
    cy: 177.17,
    rx: 165.77,
    ry: 125.94,
    transform: "translate(-8.71 13.01) rotate(-2.92)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.6,
    cy: 177.17,
    rx: 165.77,
    ry: 125.94,
    transform: "translate(-8.71 13.01) rotate(-2.92)",
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.87,213.49l-66-4.84,71.36-10.81a98.13,98.13,0,0,0,3-21.31l-76,25.15,74.58-45a99.07,99.07,0,0,0-7-22.78l-71.83,62L396.35,114A126.17,126.17,0,0,0,378.94,94.6l-49.05,97.53,28-113.39A170.66,170.66,0,0,0,332,65.52L322.82,191,302.39,56.16a207.77,207.77,0,0,0-33.28-4.82l46.74,141.33L231.09,52.22a212.12,212.12,0,0,0-39,8l118,136.65L150,78.89a156.44,156.44,0,0,0-34.66,28L306.3,203,89.74,149.44a98.31,98.31,0,0,0-4.94,35.92c.14,2.89.43,5.74.82,8.57l219.55,16.13L104.81,240.4a134.38,134.38,0,0,0,34,32.2l168-55.57L180.92,293a201.09,201.09,0,0,0,38.81,8.63l91.32-78.82-59.18,80.29q2.46-.06,4.92-.18A220.57,220.57,0,0,0,280,300.53l37.2-73.95-17.26,69.83a203.58,203.58,0,0,0,19.75-6.18l4.59-62.53,8.64,57.07q7.88-3.6,15.17-7.8L331.2,226l26.94,44.64a158.62,158.62,0,0,0,12.8-9.53L337,221.83l42.73,31.49A138.39,138.39,0,0,0,391,241l-50.27-25.29L399,230.11A114.4,114.4,0,0,0,407.87,213.49Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.65,133.43l-.1.08c7.87-12.95-19.89-10.68-37,13.28-1.3-11.12-26.48,7.14-29.48,18.33l75.57-9.55a11.74,11.74,0,0,0,8.06-18.49l-.69-1A11.74,11.74,0,0,0,374.65,133.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.29,157.5c3-7.5.66-13.75-19.29.81,5.32-8.16-5.05-5-15,2-2.09-1.19-7.09-.5-15.52,5.65,5.88-9-15.49,1.67-20,11.56L167.19,169S183.52,160.61,169.29,157.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.38,218.42c4.62-6.39-3.58-15.1-28.79,3.3,6.73-10.31-6.37-6.29-18.92,2.58-2.64-1.51-9-.64-19.62,7.14,7.43-11.38-19.57,2.11-25.34,14.6l85.6-10.82S233.37,212.82,213.38,218.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.15,205.43c.69,2.1,1.58,4.49,2.52,6.85s2,4.78,3.06,7.16c2.14,4.78,4.53,9.47,7,14,1.26,2.24,2.57,4.42,3.93,6.49s2.73,4.06,4.15,5.85a41.21,41.21,0,0,0,4.18,4.58,18.27,18.27,0,0,0,2.89,2.22l-2.38-.46a7.75,7.75,0,0,0-2.85.33,6.27,6.27,0,0,0-1.89.91c-.82.62-.79.82-.66.77a9.29,9.29,0,0,0,2-2.61c.76-1.35,1.55-2.93,2.3-4.61s1.43-3.48,2.13-5.31,1.36-3.71,2-5.62,1.31-3.85,1.92-5.8l3.73-11.79.06-.19a7,7,0,0,1,13.69,1.61,124.74,124.74,0,0,1,.17,13.38c-.1,2.22-.22,4.45-.42,6.69s-.46,4.5-.78,6.78-.76,4.57-1.29,6.93a57.41,57.41,0,0,1-2.08,7.31,33.63,33.63,0,0,1-4.32,8.4,20.17,20.17,0,0,1-5.28,5.09,17.65,17.65,0,0,1-4.78,2.2,17.24,17.24,0,0,1-6,.6,9.2,9.2,0,0,1-1.9-.32l-.48-.14a35.89,35.89,0,0,1-12-6.09,59.25,59.25,0,0,1-8-7.4,98.2,98.2,0,0,1-6.34-7.7c-1.92-2.61-3.68-5.26-5.36-7.92s-3.24-5.36-4.7-8.09-2.89-5.49-4.18-8.31-2.55-5.65-3.67-8.6a94.38,94.38,0,0,1-3.12-9.33,14,14,0,0,1,26.7-8.08Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.15,205.43c.69,2.1,1.58,4.49,2.52,6.85s2,4.78,3.06,7.16c2.14,4.78,4.53,9.47,7,14,1.26,2.24,2.57,4.42,3.93,6.49s2.73,4.06,4.15,5.85a41.21,41.21,0,0,0,4.18,4.58,18.27,18.27,0,0,0,2.89,2.22l-2.38-.46a7.75,7.75,0,0,0-2.85.33,6.27,6.27,0,0,0-1.89.91c-.82.62-.79.82-.66.77a9.29,9.29,0,0,0,2-2.61c.76-1.35,1.55-2.93,2.3-4.61s1.43-3.48,2.13-5.31,1.36-3.71,2-5.62,1.31-3.85,1.92-5.8l3.73-11.79.06-.19a7,7,0,0,1,13.69,1.61,124.74,124.74,0,0,1,.17,13.38c-.1,2.22-.22,4.45-.42,6.69s-.46,4.5-.78,6.78-.76,4.57-1.29,6.93a57.41,57.41,0,0,1-2.08,7.31,33.63,33.63,0,0,1-4.32,8.4,20.17,20.17,0,0,1-5.28,5.09,17.65,17.65,0,0,1-4.78,2.2,17.24,17.24,0,0,1-6,.6,9.2,9.2,0,0,1-1.9-.32l-.48-.14a35.89,35.89,0,0,1-12-6.09,59.25,59.25,0,0,1-8-7.4,98.2,98.2,0,0,1-6.34-7.7c-1.92-2.61-3.68-5.26-5.36-7.92s-3.24-5.36-4.7-8.09-2.89-5.49-4.18-8.31-2.55-5.65-3.67-8.6a94.38,94.38,0,0,1-3.12-9.33,14,14,0,0,1,26.7-8.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,196.72l-6.35-2.48a5.54,5.54,0,0,0-7.22,3.26L316.67,207l1.25,15.94,9.11,3.47c7.79-.93,8.41-15.5,8.41-15.5l1.67-7.83A5.55,5.55,0,0,0,333.7,196.72Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,196.72l-6.35-2.48a5.54,5.54,0,0,0-7.22,3.26L316.67,207l1.25,15.94,9.11,3.47c7.79-.93,8.41-15.5,8.41-15.5l1.67-7.83A5.55,5.55,0,0,0,333.7,196.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,204.36c7.44-15.85,29.34-15.94,47.62,20-5.58,18.23-30.38,32.17-30.38,32.17S248,223.41,256.91,204.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,204.36c7.44-15.85,29.34-15.94,47.62,20-5.58,18.23-30.38,32.17-30.38,32.17S248,223.41,256.91,204.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.81,387c-2.4-20.07-77.88-58.87-77.88-58.87l-62.89-3c-13.28,34.27-2.84,49.51,11.55,54.17a186.08,186.08,0,0,0-30.47,7.7c-8.28,2.85-11.74,13.05-6.34,20a11.47,11.47,0,0,0,5.92,4.16S374.43,442.4,367.81,387Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.81,387c-2.4-20.07-77.88-58.87-77.88-58.87l-62.89-3c-13.28,34.27-2.84,49.51,11.55,54.17a186.08,186.08,0,0,0-30.47,7.7c-8.28,2.85-11.74,13.05-6.34,20a11.47,11.47,0,0,0,5.92,4.16S374.43,442.4,367.81,387Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,408.65,185.86,394a1.4,1.4,0,0,0-.05-1.9l-10.54-10.78a8.91,8.91,0,0,0-12.63,1.85c-3.25,4.43-5,9.13-10.26,13.16-8.36,6.43-5.49,3.84-17.56,6.59-7.29,1.67-6.9,9.36-3.62,9.32,14.9-.19,28.37-.07,43.38-2A9.16,9.16,0,0,0,179,408.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.44,391.15c-2.41-20.07-88.18-58.75-88.18-58.75L194,325.09c-13.28,34.27-2.84,49.51,11.55,54.17a186.08,186.08,0,0,0-30.47,7.7c-8.28,2.85-8.38,11-6.87,18.4.87,4.23,4.17,5.09,6.45,5.71C174.63,411.07,347.06,446.55,340.44,391.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19,403.71a462.45,462.45,0,0,1-60.13-4.09.41.41,0,0,1-.35-.47.41.41,0,0,1,.47-.35c.74.11,73.67,10.75,120.39-2.75-22.67-3.45-100.41-25.21-97.92-48.88a.43.43,0,0,1,.46-.37.42.42,0,0,1,.37.46c-1.33,12.58,21.39,24.28,40.68,31.87,23.22,9.14,48.59,15.16,58.42,16.36a.42.42,0,0,1,.07.81C286.13,402,263.2,403.71,242.19,403.71Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.25,194.79c-18.43-4.48-28.14-5.68-40.18-6.21a39.86,39.86,0,0,0-41.37,44.08c5.35,51.08-1.86,82.72-2.7,94.12,34.62,22.72,89.61,13.44,98.87,4.14,10.22-41.95,6.86-88.27,5.19-108.55C295.16,211.4,287.72,197.58,276.25,194.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.25,194.79c-18.43-4.48-28.14-5.68-40.18-6.21a39.86,39.86,0,0,0-41.37,44.08c5.35,51.08-1.86,82.72-2.7,94.12,34.62,22.72,89.61,13.44,98.87,4.14,10.22-41.95,6.86-88.27,5.19-108.55C295.16,211.4,287.72,197.58,276.25,194.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.07,333.67H270a.4.4,0,0,1-.36-.46c4.5-38.67,7-103.35-.28-119.14a.42.42,0,0,1,.21-.55.42.42,0,0,1,.55.21c8.05,17.47,4.2,86.5.34,119.58A.41.41,0,0,1,270.07,333.67Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.51,159.32c1,17.72-1.23,24.61-4.23,33.16,1.83,6.87,18.85,14.86,34.21,16.86,5.53-5.85,4.71-11.65,3.29-14.26-4.48-1.74-8.72-7.16-5.44-15.2Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43,172.55v0l-5.89-2.39a15.26,15.26,0,0,0,1.25,6.89c1.66,3.54,8.09,7.11,12.43,7.51a14.81,14.81,0,0,1,1.13-4.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.09,114.61c13.6,6.79,14.62,13.94,9.75,21.38C262,126.92,269.09,114.61,269.09,114.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.58,145c6.07,16.55,8.79,26.56,19.89,32.59,16.69,9.08,35.18-5.06,34.16-23.14-.91-16.28-10.69-40.61-29.18-42.24C237.22,110.63,224.51,128.47,230.58,145Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.67,104.37a12.37,12.37,0,0,1-5.56,4.64c-1-6.85-13-17.34-34.17-17.34a33.51,33.51,0,0,1,5.77,3.67,8,8,0,0,0-5.73,6.94s-21.38,2.31-27.13,15.28c-1.07-2.86-2-6.64-1.28-9.93-2.7,2.48-6.23,14.93-1.68,20.65-9,3.47-3.81,11.71-3.81,11.71s.17-3,.82-3.66c2.49,3,.83,13.94,8.86,17.45-2.49,9.78,17.53,17.72,18,10.61s.49-11.08.49-11.08c1.9-.23,5.74-2.45,5.7-3.1-.37-5-6.54-8-8.06-10.92,5.17.89,9.63-1.34,10.36-3.44-3.35,1.17-7.12-.36-9.53-1.85.56-7.2,15-10.31,29.65-9.48a22.64,22.64,0,0,0,2.32,0,.22.22,0,0,1,.08,0h0a13.38,13.38,0,0,0,8.31-2.92C284.46,117.31,285.14,109.59,284.67,104.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.71,158.19A15.84,15.84,0,0,0,237,164.7c5.54.9,7.74-4.21,5.72-9.12-1.82-4.41-6.89-10.21-12.22-8.87S223.78,153.92,226.71,158.19Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,138.56s5,7.35,9.32,10.45c-2,2.88-6.41,2.78-6.41,2.78Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.58,158.39a11.68,11.68,0,0,1-8.91-2.78.42.42,0,1,1,.59-.6,11.3,11.3,0,0,0,10,2.26.42.42,0,0,1,.5.32.43.43,0,0,1-.32.51A14.41,14.41,0,0,1,267.58,158.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,137.39a.86.86,0,0,1-.41-.1.84.84,0,0,1-.34-1.14,8.4,8.4,0,0,1,6.27-4.51.83.83,0,0,1,.9.76.86.86,0,0,1-.77.92h0a6.74,6.74,0,0,0-4.92,3.62A.86.86,0,0,1,251.3,137.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,143a.76.76,0,0,1-.31-.13.66.66,0,0,1-.1-.92,6.59,6.59,0,0,1,5.41-2.6.64.64,0,0,1,.58.71.65.65,0,0,1-.71.59h0a5.28,5.28,0,0,0-4.26,2.11A.66.66,0,0,1,258.85,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.22,138.12a.61.61,0,0,0,.25-.23.65.65,0,0,0-.19-.9,6.55,6.55,0,0,0-5.95-.75.66.66,0,0,0-.34.86.67.67,0,0,0,.87.34h0a5.21,5.21,0,0,1,4.7.64A.65.65,0,0,0,281.22,138.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,130.9a.87.87,0,0,1-.79-.11,6.59,6.59,0,0,0-6-1.12.84.84,0,1,1-.58-1.58,8.27,8.27,0,0,1,7.54,1.33.85.85,0,0,1,.18,1.18A.88.88,0,0,1,281.2,130.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.77,207.08a39.12,39.12,0,0,0,3.31,5.4,69.92,69.92,0,0,0,4.81,5.88c1.79,1.95,3.67,3.92,5.68,5.82s4.1,3.75,6.24,5.58,4.37,3.57,6.64,5.26,4.54,3.34,6.87,4.87,4.68,3,7,4.25a53,53,0,0,0,6.45,3.08l-2.23-.45a6.15,6.15,0,0,0,2.95,0,20,20,0,0,0,4.78-1.72,47.06,47.06,0,0,0,5.47-3.22c1.86-1.27,3.7-2.71,5.54-4.23s3.69-3.14,5.48-4.85,3.62-3.45,5.38-5.26,3.53-3.66,5.24-5.56c.88-.94,1.74-1.89,2.58-2.84l2.49-2.8.25-.28a7,7,0,0,1,11.58,7.43c-.63,1.44-1.2,2.64-1.83,3.94s-1.27,2.51-1.93,3.75c-1.34,2.47-2.73,4.92-4.23,7.32s-3.07,4.78-4.76,7.11-3.48,4.61-5.39,6.87a85.11,85.11,0,0,1-6.25,6.56,58.78,58.78,0,0,1-7.52,6.08,41.57,41.57,0,0,1-9.69,5,30.94,30.94,0,0,1-12.83,1.77,9,9,0,0,1-1.58-.27l-.64-.18a73.34,73.34,0,0,1-10.82-3.94c-3.27-1.46-6.33-3.11-9.32-4.8s-5.88-3.49-8.71-5.37-5.56-3.89-8.25-6a123.88,123.88,0,0,1-15.39-14,86.34,86.34,0,0,1-7-8.56,55.55,55.55,0,0,1-6-10.72,13.95,13.95,0,0,1,25.39-11.52Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,223.71l-1.25-16,18.77,3.92s-.61,14.57-8.41,15.49Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.64,195.05l6.34,2.48a5.55,5.55,0,0,1,3.41,6.32l-1.67,7.83L311,207.76l3.47-9.46A5.54,5.54,0,0,1,321.64,195.05Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,213.09c3.64-13.7,24.48-24.72,45.5,13.42-2.32,16.46-20,29.41-20,29.41S200.85,230.62,205.51,213.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,211.68c4-16,26-31.24,47.73,8.92-2.63,18.89-21.34,35.91-21.34,35.91S195.92,232.09,201,211.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,211.68c4-16,26-31.24,47.73,8.92-2.63,18.89-21.34,35.91-21.34,35.91S195.92,232.09,201,211.68Z",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayRafiki);
export default __webpack_public_path__ + "static/media/Pray-rafiki.9d8b26b26361879c12739cb7ca76d54d.svg";
export { ForwardRef as ReactComponent };